module.exports = __webpack_public_path__ + "img/htfb_banner_sample.39591d56.png";